/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.0.0
 */
import { Fragment } from 'react';

import { FieldProps } from 'formik';

import { EInputKind } from '@components/common/Input/Input';
import { InputContainerStyled, LabelStyled } from '@components/common/Input/styled/InputStyled';

import { ETopicAttrVisibility } from '../../types/createInquiryTypes';
import {
    ErrorMessage,
    FieldRequiredStyled,
    FormItemContainerStyled,
} from './styled/CreateInquiryFormStyled';

export interface ICreateInquiryFormTextArea {
    label: string;
    placeholder: string;
    required?: boolean;
    visibility: ETopicAttrVisibility;
}


export const CreateInquiryFormTextArea = ({
    field,
    form: { touched, errors },
    ...props
}: FieldProps & ICreateInquiryFormTextArea) => {

    const isError = touched[field.name] && errors[field.name];
    const kind = isError ? EInputKind.error : EInputKind.normal;

    return (
        <FormItemContainerStyled>
            <LabelStyled htmlFor={field.name} kind={kind}>
                {props.label}
                {
                    props.required &&
                    <FieldRequiredStyled>*</FieldRequiredStyled>
                }
            </LabelStyled>
            {
                props.visibility !== ETopicAttrVisibility.READ_ONLY &&
                <Fragment>
                    <InputContainerStyled kind={kind}>
                        <textarea
                            {...field}
                            {...props}
                            placeholder={props.placeholder}
                        />
                    </InputContainerStyled>
                    {
                        isError &&
                        <ErrorMessage>
                            {
                                errors[field.name]
                            }
                        </ErrorMessage>
                    }
                </Fragment>
            }
        </FormItemContainerStyled>
    );
};
